import * as React from 'react';

import {
  DimeItem,
  DimeItemContent,
  DimeItemGroup,
  DimeItemMedia,
  DimeItemTitle,
} from './DimeItem.js';
import { isBlankValue } from './lib/is-blank-value.js';
import { cn } from './lib/utils.js';

export type DimeCardShellMetaItem = {
  icon: React.ReactElement<{ className?: string; 'aria-hidden'?: boolean }>;
  label: string;
  value: React.ReactNode;
};

export type DimeCardShellMetaProps = Readonly<{
  items: DimeCardShellMetaItem[];
  /** Names the list, so a page with more than one row distinguishes them. */
  label?: string;
  className?: string;
}>;

export function DimeCardShellMeta({ items, label, className }: DimeCardShellMetaProps) {
  return (
    <DimeItemGroup
      aria-label={label}
      className={cn('w-auto flex-row flex-wrap items-center gap-x-4 gap-y-1', className)}
    >
      {items.map((item) => (
        <DimeItem
          key={item.label}
          className="w-auto flex-nowrap gap-1.5 whitespace-nowrap border-0 p-0"
        >
          <DimeItemMedia variant="icon" className="self-center text-muted-foreground">
            {React.cloneElement(item.icon, {
              'aria-hidden': true,
              className: cn('shrink-0 size-4', item.icon.props.className),
            })}
          </DimeItemMedia>
          <DimeItemContent className="flex-none justify-center">
            <DimeItemTitle className="line-clamp-none flex gap-1.5 text-sm font-normal text-muted-foreground">
              <span>{item.label}</span>
              <span className="font-medium text-foreground">
                {isBlankValue(item.value) ? '—' : item.value}
              </span>
            </DimeItemTitle>
          </DimeItemContent>
        </DimeItem>
      ))}
    </DimeItemGroup>
  );
}
